import React from 'react';
import Text from 'components/Core/Text';
import { WebsiteImage } from 'components/TitleDescription';
import getBreakpointView from 'utils/getBreakpointView';
import HoverableHyperLink from 'components/Core/HyperLink/HoverableHyperLink';

const Header = ({ logo }) => {
  const isMobile = getBreakpointView(['xs', 'sm']);

  return (
    <>
      <div className="toolbox-section--header">
        <WebsiteImage className="toolbox-section--logo" src={logo.src} alt={logo.alt} />
        {!isMobile && <ViewAllResources />}
      </div>
      <div className="toolbox-section--copy">
        <Text type="p" size="20px" textColor="white">
          A place for contractors to access the best content — articles, webinars, podcasts,
          industry-leading voices and expert advice, all in one place!
        </Text>
      </div>
      {isMobile && <ViewAllResources />}
    </>
  );
};
const ViewAllResources = () => (
  <div className="toolbox-section--view-all-resources-wrapper">
    <HoverableHyperLink
      className="toolbox-section--view-all-resources"
      iconColor="white"
      href="/toolbox"
      text="View All Resources"
    />
  </div>
);
export default Header;
